// Debug utility for production builds
const isDebugMode = () => {
  // Check if we're in debug mode via window object or localStorage
  if (typeof window !== 'undefined') {
    return window.location.search.includes('debug=true') || 
           localStorage.getItem('debug') === 'true' ||
           window.location.hash.includes('debug=true');
  }
  return false;
};

export const debug = {
  log: (message: string, ...args: unknown[]) => {
    if (isDebugMode()) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },
  
  error: (message: string, ...args: unknown[]) => {
    if (isDebugMode()) {
      console.error(`[DEBUG ERROR] ${message}`, ...args);
    }
  },
  
  warn: (message: string, ...args: unknown[]) => {
    if (isDebugMode()) {
      console.warn(`[DEBUG WARN] ${message}`, ...args);
    }
  },
  
  info: (message: string, ...args: unknown[]) => {
    if (isDebugMode()) {
      console.info(`[DEBUG INFO] ${message}`, ...args);
    }
  },
  
  // Log router state for debugging
  router: (router: { state: { location: { hash: string; pathname: string } } }) => {
    if (isDebugMode()) {
      console.log('[DEBUG ROUTER] State:', router.state);
      console.log('[DEBUG ROUTER] Location:', router.state.location);
      console.log('[DEBUG ROUTER] Hash:', router.state.location.hash);
      console.log('[DEBUG ROUTER] Pathname:', router.state.location.pathname);
    }
  },
  
  // Log component props and state
  component: (componentName: string, props?: Record<string, unknown>, state?: Record<string, unknown>) => {
    if (isDebugMode()) {
      console.log(`[DEBUG COMPONENT] ${componentName}:`, { props, state });
    }
  }
};
